import { Helmet } from 'react-helmet';
import { motion } from 'framer-motion';

const AvisoLegal = () => {
  return (
    <>
      <Helmet>
        <title>Aviso Legal | Jarad</title>
        <meta name="description" content="Aviso legal de Jarad. Información legal sobre la empresa, el sitio web y sus condiciones de uso." />
      </Helmet>

      <div className="bg-gray-50 py-12">
        <motion.div
          className="container mx-auto px-4 max-w-4xl"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <div className="bg-white shadow-sm rounded-lg p-8 md:p-12">
            <h1 className="text-3xl font-bold text-gray-900 mb-8 border-b pb-4">
              AVISO LEGAL
            </h1>

            <div className="prose prose-blue max-w-none text-gray-600">

              <div className="mb-8">
                <h2 className="text-xl font-bold text-gray-800 mb-4">LEY DE LOS SERVICIOS DE LA SOCIEDAD DE LA INFORMACIÓN (LSSI)</h2>
                <p className="mb-4">
                  VALLE GALBARRO S.L., responsable del sitio web, en adelante RESPONSABLE, pone a disposición
                  de los usuarios el presente documento, con el que pretende dar cumplimiento a las obligaciones
                  dispuestas en la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y de
                  Comercio Electrónico (LSSICE), BOE N.º 166, así como informar a todos los usuarios del sitio web
                  respecto a cuáles son las condiciones de uso.
                </p>
                <p className="mb-4">
                  Toda persona que acceda a este sitio web asume el papel de usuario, comprometiéndose a la
                  observancia y cumplimiento riguroso de las disposiciones aquí dispuestas, así como a cualquier otra
                  disposición legal que fuera de aplicación.
                </p>
                <p>
                  VALLE GALBARRO S.L. se reserva el derecho de modificar cualquier tipo de información que pudiera
                  aparecer en el sitio web, sin que exista obligación de preavisar o poner en conocimiento de los
                  usuarios dichas obligaciones, entendiéndose como suficiente la publicación en el sitio web de VALLE
                  GALBARRO S.L.
                </p>
              </div>

              <div className="mb-8">
                <h2 className="text-2xl font-bold text-gray-800 mb-4">1. DATOS IDENTIFICATIVOS</h2>
                <ul className="list-none space-y-2 pl-0">
                  <li><strong>Nombre de dominio:</strong> jaradpetfood.com</li>
                  <li><strong>Nombre comercial:</strong> VALLE GALBARRO S.L.</li>
                  <li><strong>Denominación social:</strong> VALLE GALBARRO S.L.</li>
                  <li><strong>NIF:</strong> B41658154</li>
                  <li><strong>Domicilio social:</strong> C/ Ctra. de Utrera, 19-A 41760 El Coronil - Sevilla</li>
                  <li><strong>Teléfono:</strong> +34 955 83 68 23</li>
                  <li><strong>E-mail:</strong> info@jaradpetfood.com</li>
                  <li><strong>Inscrita en el Registro (Mercantil / Público):</strong> de Sevilla, Tomo 1967, libro 1º, sección 1ª de Sociedades, folio 199, hoja Nº SE – 18.763, Inscrip. 1º</li>
                </ul>
              </div>

              <div className="mb-8">
                <h2 className="text-2xl font-bold text-gray-800 mb-4">2. DERECHOS DE PROPIEDAD INTELECTUAL E INDUSTRIAL</h2>
                <p className="mb-4">
                  El sitio web, incluyendo a título enunciativo pero no limitativo su programación, edición, compilación y
                  demás elementos necesarios para su funcionamiento, los diseños, logotipos, texto y/o gráficos, son
                  propiedad del RESPONSABLE o, si es el caso, dispone de licencia o autorización expresa por parte de
                  los autores. Todos los contenidos del sitio web se encuentran debidamente protegidos por la normativa
                  de propiedad intelectual e industrial, así como inscritos en los registros públicos correspondientes.
                </p>
                <p className="mb-4">
                  Independientemente de la finalidad para la que fueran destinados, la reproducción total o parcial, uso,
                  explotación, distribución y comercialización, requiere en todo caso la autorización escrita previa por
                  parte del RESPONSABLE. Cualquier uso no autorizado previamente se considera un incumplimiento
                  grave de los derechos de propiedad intelectual o industrial del autor.
                </p>
                <p className="mb-4">
                  Los diseños, logotipos, texto y/o gráficos ajenos al RESPONSABLE y que pudieran aparecer en el sitio
                  web, pertenecen a sus respectivos propietarios, siendo ellos mismos responsables de cualquier posible
                  controversia que pudiera suscitarse respecto a los mismos. El RESPONSABLE autoriza expresamente
                  a que terceros puedan redirigir directamente a los contenidos concretos del sitio web, y en todo caso
                  redirigir al sitio web principal de semillasjarad.es/.
                </p>
                <p className="mb-4">
                  El RESPONSABLE reconoce a favor de sus titulares los correspondientes derechos de propiedad
                  intelectual e industrial, no implicando su sola mención o aparición en el sitio web la existencia de
                  derechos o responsabilidad alguna sobre los mismos, como tampoco respaldo, patrocinio o
                  recomendación por parte del mismo.
                </p>
                <p>
                  Para realizar cualquier tipo de observación respecto a posibles incumplimientos de los derechos de
                  propiedad intelectual o industrial, así como sobre cualquiera de los contenidos del sitio web, puede
                  hacerlo a través del correo electrónico info@semillasjarad.es.
                </p>
              </div>

              <div className="mb-8">
                <h2 className="text-2xl font-bold text-gray-800 mb-4">3. EXENCIÓN DE RESPONSABILIDADES</h2>
                <p className="mb-6">
                  El RESPONSABLE se exime de cualquier tipo de responsabilidad derivada de la información publicada
                  en su sitio web siempre que no tenga conocimiento efectivo de que esta información haya sido
                  manipulada o introducida por un tercero ajeno al mismo o, si lo tiene, haya actuado con diligencia para
                  retirar los datos o hacer imposible el acceso a ellos.
                </p>

                <h3 className="text-xl font-semibold text-gray-800 mb-3">Uso de Cookies</h3>
                <p className="mb-4">
                  Este sitio web puede utilizar cookies técnicas (pequeños archivos de información que el servidor envía
                  al ordenador de quien accede a la página) para llevar a cabo determinadas funciones que son
                  consideradas imprescindibles para el correcto funcionamiento y visualización del sitio. Las cookies
                  utilizadas tienen, en todo caso, carácter temporal, con la única finalidad de hacer más eficaz la
                  navegación, y desaparecen al terminar la sesión del usuario. En ningún caso, estas cookies
                  proporcionan por sí mismas datos de carácter personal y no se utilizarán para la recogida de los
                  mismos.
                </p>
                <p className="mb-4">
                  Mediante el uso de cookies también es posible que el servidor donde se encuentra la web reconozca el
                  navegador utilizado por el usuario con la finalidad de que la navegación sea más sencilla, permitiendo,
                  por ejemplo, el acceso de los usuarios que se hayan registrado previamente a las áreas, servicios,
                  promociones o concursos reservados exclusivamente a ellos sin tener que registrarse en cada visita.
                  También se pueden utilizar para medir la audiencia, parámetros de tráfico, controlar el progreso y
                  número de entradas, etc., siendo en estos casos cookies prescindibles técnicamente, pero
                  beneficiosas para el usuario. Este sitio web no instalará cookies prescindibles sin el consentimiento
                  previo del usuario.
                </p>
                <p className="mb-4">
                  Este sitio web utiliza cookies propias y de terceros para fines analíticos y para mostrarle publicidad
                  personalizada en base a un perfil elaborado a partir de sus hábitos de navegación (por ejemplo,
                  páginas visitadas). A todo usuario que visita la web se le informa del uso de estas cookies mediante un
                  banner flotante. En el caso de aceptar su uso, el banner desaparecerá, aunque en todo momento
                  podrá revocar el consentimiento y obtener más información consultando nuestra Política de cookies.
                </p>
                <p className="mb-6">
                  El usuario tiene la posibilidad de configurar su navegador para ser alertado de la recepción de cookies
                  y para impedir su instalación en su equipo. Por favor, consulte las instrucciones de su navegador para
                  ampliar esta información.
                </p>

                <h3 className="text-xl font-semibold text-gray-800 mb-3">Política de enlaces</h3>
                <p className="mb-4">
                  Desde el sitio web, es posible que se redirija a contenidos de terceros sitios web. Dado que el
                  RESPONSABLE no puede controlar siempre los contenidos introducidos por terceros en sus
                  respectivos sitios web, no asume ningún tipo de responsabilidad respecto a dichos contenidos. En todo
                  caso, procederá a la retirada inmediata de cualquier contenido que pudiera contravenir la legislación
                  nacional o internacional, la moral o el orden público, procediendo a la retirada inmediata de la
                  redirección a dicho sitio web, poniendo en conocimiento de las autoridades competentes el contenido
                  en cuestión.
                </p>
                <p className="mb-4">
                  El RESPONSABLE no se hace responsable de la información y contenidos almacenados, a título
                  enunciativo pero no limitativo, en foros, chats, generadores de blogs, comentarios, redes sociales o
                  cualquier otro medio que permita a terceros publicar contenidos de forma independiente en la página
                  web del RESPONSABLE. Sin embargo, y en cumplimiento de lo dispuesto en los artículos 11 y 16 de
                  la LSSICE, se pone a disposición de todos los usuarios, autoridades y fuerzas de seguridad,
                  colaborando de forma activa en la retirada o, en su caso, bloqueo de todos aquellos contenidos que
                  puedan afectar o contravenir la legislación nacional o internacional, los derechos de terceros o la moral
                  y el orden público. En caso de que el usuario considere que existe en el sitio web algún contenido que
                  pudiera ser susceptible de esta clasificación, se ruega lo notifique de forma inmediata al administrador
                  del sitio web.
                </p>
                <p className="mb-6">
                  Este sitio web se ha revisado y probado para que funcione correctamente. En principio, puede
                  garantizarse el correcto funcionamiento los 365 días del año, 24 horas al día. Sin embargo, el
                  RESPONSABLE no descarta la posibilidad de que existan ciertos errores de programación, o que
                  acontezcan causas de fuerza mayor, catástrofes naturales, huelgas o circunstancias semejantes que
                  hagan imposible el acceso a la página web.
                </p>

                <h3 className="text-xl font-semibold text-gray-800 mb-3">Direcciones IP</h3>
                <p>
                  Los servidores del sitio web podrán detectar de manera automática la dirección IP y el nombre de
                  dominio utilizados por el usuario. Una dirección IP es un número asignado automáticamente a un
                  ordenador cuando este se conecta a Internet. Toda esta información se registra en un fichero de
                  actividad del servidor debidamente inscrito que permite el posterior procesamiento de los datos con el
                  fin de obtener mediciones únicamente estadísticas que permitan conocer el número de impresiones de
                  páginas, el número de visitas realizadas a los servidores web, el orden de visitas, el punto de acceso,
                  etc.
                </p>
              </div>

              <div className="mb-8">
                <h2 className="text-2xl font-bold text-gray-800 mb-4">4. LEY APLICABLE Y JURISDICCIÓN</h2>
                <p>
                  Para la resolución de todas las controversias o cuestiones relacionadas con el presente sitio web o de
                  las actividades en él desarrolladas, será de aplicación la legislación española, a la que se someten
                  expresamente las partes, siendo competentes para la resolución de todos los conflictos derivados o
                  relacionados con su uso los Juzgados y Tribunales del domicilio del USUARIO o el lugar del
                  cumplimiento de la obligación.
                </p>
              </div>

            </div>
          </div>
        </motion.div>
      </div>
    </>
  );
};

export default AvisoLegal;